import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import './SearchSection.scss';

/**
 * Component for rendering the search bar section
 */
export const SearchSection = ({
    searchTerm,
    onSearchChange,
    onClearSearch
}) => {
    const { t } = useLanguage();

    return (
        <div className="search-section">
            <div className="search-bar">
                <input
                    type="text"
                    placeholder={t('common.search')}
                    value={searchTerm}
                    onChange={onSearchChange}
                    className="search-input"
                />
                {searchTerm && (
                    <button
                        className="search-clear-icon"
                        onClick={onClearSearch}
                        type="button"
                        aria-label={t('common.clear')}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18 6L6 18M6 6L18 18"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
};

export default SearchSection;
